const profileData = {
    id: "8D4VFtkiIuw",
    name: "Susan Wilkinson",
    description: "UI/UX Designer",
    connections: 767,
    views: 60,
    social: {
        linkedin: "https://www.linkedin.com/in/susanWilkinson/",
    },
    profile_image: {
        small: "https://images.unsplash.com/profile-1627926344335-e420d65c34f7?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=32&w=32",
        medium: "https://images.unsplash.com/profile-1627926344335-e420d65c34f7?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=64&w=64",
        large: "https://images.unsplash.com/profile-1627926344335-e420d65c34f7?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=128&w=128",
    },
};

export default profileData;
